var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "link-object-dialog",
      attrs: {
        visible: _vm.isVisible,
        title: _vm.showSearch
          ? _vm.$t.__("common.object.linkObjectDialog.add_related_title")
          : _vm.$t.__("common.object.linkObjectDialog.update_related_title"),
        primaryAction: _vm.primaryAction,
        secondaryActions: _vm.secondaryActions
      },
      on: { "update:visible": _vm.handleClose }
    },
    [
      _c(
        "template",
        { slot: "default" },
        [
          _vm.hasError
            ? _c("CompassAlert", {
                attrs: {
                  type: "error",
                  description: _vm.$t.__(
                    "common.object.linkObjectDialog.error_message"
                  ),
                  showClose: false
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("SearchObjectToLinkComponent", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showSearch,
                expression: "showSearch"
              }
            ],
            attrs: {
              isVisible: _vm.showSearch,
              emptyStateData: _vm.emptyStateData
            },
            on: { objectSelected: _vm.handleSelectObject }
          }),
          _vm._v(" "),
          !_vm.showSearch
            ? _c(
                "div",
                { staticClass: "link-object-dialog__content" },
                [
                  _c(
                    "div",
                    { staticClass: "typographies-paragraph-medium-semibold" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t.n__(
                              "common.object.linkObjectDialog.related_listing_title",
                              null,
                              _vm.objectsSelected.length,
                              _vm.objectsSelected.length
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "link-object-dialog__object-container" },
                    [
                      _vm.objectsSelected.length > 0
                        ? [
                            _vm._l(_vm.objectsSelected, function(
                              objectSelected
                            ) {
                              return [
                                _vm.isCompany(objectSelected)
                                  ? _c("BlockCompany", {
                                      key:
                                        "company-" +
                                        objectSelected.data.type +
                                        "-" +
                                        objectSelected.data.id,
                                      attrs: {
                                        data: objectSelected.data,
                                        showMobile: false,
                                        showAddress: false,
                                        variant: "linked"
                                      },
                                      on: {
                                        unlink: function($event) {
                                          return _vm.unlinkObject(
                                            objectSelected
                                          )
                                        }
                                      }
                                    })
                                  : _vm.isContact(objectSelected)
                                  ? _c("BlockContact", {
                                      key: "contact-" + objectSelected.data.id,
                                      attrs: {
                                        data: objectSelected.data,
                                        showPhone: false,
                                        variant: "linked"
                                      },
                                      on: {
                                        unlink: function($event) {
                                          return _vm.unlinkObject(
                                            objectSelected
                                          )
                                        }
                                      }
                                    })
                                  : _vm.isDocument(objectSelected)
                                  ? _c("BlockDocument", {
                                      key:
                                        "document-" +
                                        objectSelected.data.type +
                                        "-" +
                                        objectSelected.data.id,
                                      attrs: {
                                        data: objectSelected.data,
                                        variant: "linked"
                                      },
                                      on: {
                                        unlink: function($event) {
                                          return _vm.unlinkObject(
                                            objectSelected
                                          )
                                        }
                                      }
                                    })
                                  : _vm.isOpportunity(objectSelected)
                                  ? _c("BlockOpportunity", {
                                      key:
                                        "opportunity-" + objectSelected.data.id,
                                      attrs: {
                                        data: objectSelected.data,
                                        variant: "linked"
                                      },
                                      on: {
                                        unlink: function($event) {
                                          return _vm.unlinkObject(
                                            objectSelected
                                          )
                                        }
                                      }
                                    })
                                  : _vm.isIndividual(objectSelected)
                                  ? _c("BlockIndividual", {
                                      key:
                                        "individual-" +
                                        objectSelected.data.type +
                                        "-" +
                                        objectSelected.data.id,
                                      attrs: {
                                        data: objectSelected.data,
                                        variant: "linked"
                                      },
                                      on: {
                                        unlink: function($event) {
                                          return _vm.unlinkObject(
                                            objectSelected
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ]
                            })
                          ]
                        : _c(
                            "div",
                            {
                              staticClass:
                                "object-block--empty typographies-heading-h4"
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t.__(
                                      "common.object.linkObjectDialog.no_related_objects"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("CompassPlainButton", {
                    attrs: {
                      label: _vm.$t.__(
                        "common.object.linkObjectDialog.actions.add_new_related"
                      )
                    },
                    on: {
                      click: function($event) {
                        _vm.showSearch = true
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }